"use client";

import React from "react";

const iconClass = "shrink-0 text-[#1A1A1A]";

export function PhoneIcon({ className }: { className?: string }) {
    return (
        <svg
            width={28}
            height={28}
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className ?? iconClass}
            aria-hidden
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.14556 4.08174C3.14822 4.08174 3.08156 4.15107 2.99756 4.23374C2.67489 4.54707 2.00689 5.19907 2.00016 6.56307C1.98956 8.47107 3.24422 12.0137 9.28556 18.0537C15.2989 24.0644 18.8362 25.3337 20.7482 25.3337H20.7762C22.1402 25.3271 22.7909 24.6577 23.1056 24.3364C23.2016 24.2377 23.2789 24.1657 23.3336 24.1204C24.6616 22.7844 25.3416 21.7897 25.3349 21.1524C25.3256 20.5017 24.5162 19.7324 23.3976 18.6684C23.0416 18.3297 22.6549 17.9617 22.2469 17.5537C21.1896 16.4991 20.6656 16.6791 19.5136 17.0844C17.9202 17.6431 15.7336 18.4031 12.3362 15.0044C8.93356 11.6044 9.69489 9.4204 10.2522 7.82707C10.6549 6.67507 10.8389 6.14974 9.78022 5.09107C9.36556 4.67774 8.99356 4.28574 8.65089 3.92574C7.59356 2.81374 6.83089 2.00974 6.18422 2.0004H6.17356C5.53489 2.0004 4.54289 2.68307 3.13889 4.08707C3.14289 4.08307 3.14422 4.08174 3.14556 4.08174ZM20.7496 27.3337C17.4269 27.3337 13.0949 24.6884 7.87222 19.4684C2.62956 14.2271 -0.0197765 9.88174 0.000111137 6.5524C0.0122235 4.3524 1.16556 3.22574 1.59889 2.80307C1.62156 2.77507 1.69889 2.69907 1.72556 2.6724C3.63756 0.75907 4.92689 -0.0142634 6.20956 0.000198849C7.69889 0.0204033 8.75889 1.13507 10.1002 2.54707C10.4322 2.8964 10.7922 3.2764 11.1936 3.6764C13.1402 5.62307 12.5856 7.21107 12.1402 8.48574C11.6549 9.8764 11.2349 11.0764 13.7496 13.5911C16.2669 16.1057 17.4669 15.6857 18.8522 15.1964C20.1282 14.7511 21.7122 14.1937 23.6616 16.1404C24.0562 16.5351 24.4309 16.8911 24.7762 17.2204C26.1949 18.5684 27.3149 19.6337 27.3338 21.1271C27.3496 22.4004 26.5762 23.6977 24.6669 25.6084L23.8216 25.0351L24.5362 25.7337C24.1136 26.1671 22.9882 27.3217 20.7869 27.3337H20.7496Z"
                fill="currentColor"
            />
        </svg>
    );
}

export function MailIcon({ className }: { className?: string }) {
    return (
        <svg
            width={29}
            height={26}
            viewBox="0 0 29 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className ?? iconClass}
            aria-hidden
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.8787 0C25.3187 0 28.6667 3.62267 28.6667 8.42667V17.584C28.6667 20.0427 27.7973 22.264 26.2173 23.84C24.8 25.252 22.9613 26 20.9 26H7.76267C5.70533 26 3.868 25.2533 2.44933 23.84C0.869333 22.264 0 20.0427 0 17.584V8.42667C0 3.62267 3.348 0 7.788 0H20.8787ZM20.8787 2H7.788C4.43467 2 2 4.70267 2 8.42667V17.584C2 19.508 2.66133 21.2267 3.86133 22.4227C4.896 23.456 6.24667 24 7.76667 24H20.8787C20.8813 23.9973 20.892 24 20.9 24C22.4213 24 23.7707 23.456 24.8053 22.4227C26.0067 21.2267 26.6667 19.508 26.6667 17.584V8.42667C26.6667 4.70267 24.232 2 20.8787 2ZM22.98 8.17173C23.328 8.59973 23.2627 9.22907 22.8347 9.5784L16.9093 14.3944C16.16 14.9891 15.264 15.2864 14.3693 15.2864C13.4773 15.2864 12.588 14.9917 11.844 14.4024L5.864 9.58107C5.43333 9.2344 5.36667 8.60373 5.712 8.1744C6.06 7.7464 6.68933 7.6784 7.11867 8.02373L13.0933 12.8397C13.844 13.4344 14.9013 13.4344 15.6573 12.8344L21.572 8.0264C22.0013 7.67573 22.6307 7.7424 22.98 8.17173Z"
                fill="currentColor"
            />
        </svg>
    );
}

export function AddressIcon({ className }: { className?: string }) {
    return (
        <svg
            width={22}
            height={26}
            viewBox="0 0 22 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className ?? iconClass}
            aria-hidden
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 0C17.0653 0 22 4.972 22 11.084C22 18.5973 13.392 26 11 26C8.608 26 0 18.5973 0 11.084C0 4.972 4.93467 0 11 0ZM11 2C6.03733 2 2 6.076 2 11.084C2 17.456 9.49867 23.664 11 23.9947C12.5013 23.6627 20 17.4547 20 11.084C20 6.076 15.9627 2 11 2ZM11.0013 6.66667C13.3907 6.66667 15.3347 8.61067 15.3347 11.0013C15.3347 13.3907 13.3907 15.3333 11.0013 15.3333C8.612 15.3333 6.668 13.3907 6.668 11.0013C6.668 8.61067 8.612 6.66667 11.0013 6.66667ZM11.0013 8.66667C9.71467 8.66667 8.668 9.71333 8.668 11.0013C8.668 12.288 9.71467 13.3333 11.0013 13.3333C12.288 13.3333 13.3347 12.288 13.3347 11.0013C13.3347 9.71333 12.288 8.66667 11.0013 8.66667Z"
                fill="currentColor"
            />
        </svg>
    );
}

export function WhatsAppIcon({ className }: { className?: string }) {
    return (
        <svg
            width={28}
            height={28}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className ?? iconClass}
            aria-hidden
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"
                fill="currentColor"
            />
        </svg>
    );
}
